/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EventStatus {
  Ready = 'ready',
  InPreparation = 'inPreparation'
}
